module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Thin.5b87b67.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Thin.woff2
// module id = lp5h
// module chunks = 0